import React from 'react'

import VideoItem from './VideoItem'
import styled from 'styled-components'

const ListStyles = styled.div`
  display: flex;
  flex-direction: row-reverse;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
  }
`

const VideoList = ({ videos, onVideoSelect }) => {
  const listOfVideos = videos.map((video, id) => <VideoItem onVideoSelect={onVideoSelect} key={id} video={video} />)
  return (
    <ListStyles>
      {listOfVideos}
    </ListStyles>
  )
}

export default VideoList
